import SubcategoryPill from 'components/prizes/SubcategorySelector/SubcategoryPill';
import { useEffect, useRef, useState } from 'react';
import { ASSET_PREFIX } from 'utils/constants';

interface ISubcategorySelectorProps {
  subcategories: (string | null)[];
  selectedSubcategory: string | null;
  setSelectedSubcategory: (subcategories: string | null) => void;
}

const SubcategorySelector = ({ subcategories, selectedSubcategory, setSelectedSubcategory }: ISubcategorySelectorProps) => {
  // Add null to the beginning o
  const selectorContainer = useRef<HTMLDivElement>(null);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [contentHeight, setContentHeight] = useState(0);
  const height2Rows = 108

  function handleResize() {
    if (selectorContainer.current){
      const { height } = selectorContainer.current.getBoundingClientRect();
      setContentHeight(height);
    }
  }

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  subcategories = [null, ...subcategories];
  return (
    <>
      <div className={`subcategorySizeLimit${isExpanded ? ' subcategorySizeExpanded' : ''}`}>
        <div ref={selectorContainer} className='subcategorySelectorContainer'>
          {subcategories.map((subcategory) => (
            <SubcategoryPill
              key={subcategory ?? 'NA'}
              subcategory={subcategory}
              selected={subcategory === selectedSubcategory}
              onClick={() => setSelectedSubcategory(subcategory)}
            />
          ))}
        </div>
      </div>
      {contentHeight > height2Rows ?
        <div className="expandHolder" >
          <img
            className={`expandIcon${isExpanded ? ' expanded' : ''}`}
            src={`${ASSET_PREFIX}/images/plus-circle.svg`}
            onClick={() => setIsExpanded(!isExpanded)}
          />
        </div>
        :
        null
      }
      <style jsx>
        {`
          .expandHolder {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 20px;
          }
          .expandIcon {
            cursor: pointer;
            width: 28px;
            height: 28px;
            transition: 0.5s ease-in-out;
            transform: rotate(0deg);

          }
          .expanded {
            transform: rotate(-45deg);
          }
          .subcategorySizeLimit {
            max-height: ${height2Rows}px;
            overflow: hidden;
            transition: max-height 0.5s ease-in-out;
          }
          .subcategorySizeExpanded {
            max-height: ${contentHeight}px;
          }
          .subcategorySelectorContainer {
            display: flex;
            flex-wrap: wrap;
            justify-content: stretch;
          }
        `}
      </style>
    </>
  );
};

export default SubcategorySelector;